import { isProd } from './enviroment';

function setCookie(name: string, value: string, daysFromNow = 365): void {
  if (typeof document === 'undefined') return;

  const date = new Date();
  date.setTime(date.getTime() + daysFromNow * 24 * 60 * 60 * 1000);
  const security = isProd ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; samesite=lax${security}`;
}

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const nameEQ = name + '=';
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(nameEQ))
    ?.substring(nameEQ.length);
  if (cookieValue) {
    return decodeURIComponent(cookieValue);
  }

  // migrate existing localStorage to cookies
  const fallback = localStorage.getItem(name);
  if (fallback) {
    setCookie(name, fallback);
    // localStorage.removeItem(name); // ticket: BMCOTV-3621
  }
  return fallback;
}

function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return;

  // Set the cookie with an immediate past expiry date
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}

export function setSecureStorage(key: string, value: string) {
  setCookie(key, value);
  // workaround for browsers with higher security standards, comments on this ticket : https://jira.int.bellmedia.ca/browse/BMCOTV-3621
  localStorage.setItem(key, value);
}

export function getSecureStorage(key: string): string | null {
  return getCookie(key);
}

export function removeSecureStorage(key: string) {
  try {
    deleteCookie(key);
  } catch (error) {
    console.error(`Failed to delete cookie for ${key}:`, error);
  }

  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove localStorage item for ${key}:`, error);
  }
}

export function setSessionStorage(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  const oldValue = sessionStorage.getItem(key);
  window.sessionStorage.setItem(key, value);
  window.dispatchEvent(
    new StorageEvent('sessionStorage', { key, oldValue, newValue: value })
  );
}

export function getSessionStorage(key: string): string | null {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(key);
}

export function removeSessionStorage(key: string): void {
  if (typeof window === 'undefined') return;
  const oldValue = sessionStorage.getItem(key);
  window.sessionStorage.removeItem(key);
  window.dispatchEvent(
    new StorageEvent('sessionStorage', { key, oldValue, newValue: null })
  );
}
